import "regenerator-runtime/runtime";
import _objectDestructuringEmpty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/objectDestructuringEmpty.js";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { devSetting, debuggerMode } from "../setting";

function checkShouldReport(module) {
  return debuggerMode || devSetting.开启日志 || devSetting.按模块开启日志.includes(module);
}

function report(shouldReport, module, msg) {
  console[shouldReport ? 'debug' : 'log']("[".concat(module, "] ").concat(msg));
}

export function debug(module) {
  var shouldReport = checkShouldReport(module);
  return function (msg) {
    report(shouldReport, module, msg);
  };
}
export function log(msg) {
  var module = 'log';
  var shouldReport = checkShouldReport(module);
  report(shouldReport, module, msg);
}
export function setup() {
  return _setup.apply(this, arguments);
}

function _setup() {
  _setup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};

            _objectDestructuringEmpty(_ref);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setup.apply(this, arguments);
}